import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import { getImageUrl } from '../../utils/getImageUrl';


const CurriculumCard = ({ item }) => {


    return (
        <Box sx={{
            boxShadow: "0px 4px 4px 0px #00000040",
            bgcolor: "primary.main",
            borderRadius: "1rem",
            border: "1px solid #F0F0F0",
            display: "flex",
            gap: 0,
            overflow: "hidden"
        }}>

            <Box
                sx={{
                    width: { xs: "35%", sm: "20%", md: "25%" },
                    position: "relative",
                    overflow: "hidden",
                }}
            >

                <Box
                    component="img"
                    src={item?.imageUrl ? getImageUrl(item.imageUrl) : ""}
                    alt={item?.listItemHeading || "image"}
                    sx={{
                        width: "80%",
                        height: "auto",
                        objectFit: "contain",
                        position: "absolute",
                        left: "0%",
                        top: "0%",
                        borderRadius: 0
                    }}
                />

            </Box>

            <Box sx={{ width: { xs: "65%", sm: "80%", md: "75%" }, py: 2, pr: 1 }} >
                <Typography variant='body1' fontWeight={500} dangerouslySetInnerHTML={{ __html: item?.listItemHeading }} />


                <Typography variant='body2' color="grey.400 " mt={1} fontWeight={300} dangerouslySetInnerHTML={{ __html: item?.listItemContent }} />



            </Box>

        </Box>
    )
}

export default CurriculumCard
